import { defineMessages } from "react-intl";

const messages = defineMessages({
    text: {
        id: "join.modal.qrCode",
    },
});

export default messages;
